import { useContext } from "react";
import { OrderData } from "./types/OrderData";
import { isFinite } from "lodash";

const incrementSubfileSuffix = (suffix: string) => {
  const trimmed = suffix.trim();
  const num = Number(trimmed);

  return isFinite(num) && Number.isInteger(num) ? (num + 1).toString() : suffix;
};

export function serializeOrderState(ctx: OrderData) {
  const {
    isRush,
    isConfidential,
    projectName,
    selectedClient,
    selectedTeam,
    selectedMarketingRep1,
    selectedMarketingRep2,
    selectedMarketingRep3,
    selectedFunder,
    selectedAccountRep,
    selectedClientPointOfContactType,
    loans,
    purchasePrice,
    transactionType,
    productTypeList,
    selectedProductType,
    settlementStatementType,
    propertyUse,
    properties,
    relatedOrders,
    subfileSuffix,
    priorPolicyAmount,
    priorPolicyDate,
    priorPolicyUnderwriterList,
    underwriterList,
    titleCompanyList,
    settlementAgentList,
    selectedPriorPolicyUnderwriter,
    selectedUnderwriter,
    selectedTitleCompany,
    settlementDate,
    selectedSettlementAgent,
    matchedOrders,
    matchedOldOrders,
    matchedOrdersIsLoading,
    matchedOTSOrders,
    notes,
    relationshipTypeList,
    vestingList,
    contactTypeList,
    sellers,
    sellersAttorney,
    sellersParalegal,
    buyers,
    buyersAttorney,
    buyersParalegal,
    additionalContacts,
    submissionAttempted,
    autoFilled,
    totalRelatedOrdersCharLength,
    totalCharCount,
    orderPrincipal,
    orderType,
    selectedBuyerPrincipals,
    selectedSellerPrincipals,
    dealOwner
  } = ctx;

  return {
    isRush,
    isConfidential,
    projectName,
    selectedClient,
    selectedTeam,
    selectedMarketingRep1,
    selectedMarketingRep2,
    selectedMarketingRep3,
    selectedFunder,
    selectedAccountRep,
    selectedClientPointOfContactType,
    loans,
    purchasePrice,
    transactionType,
    productTypeList,
    selectedProductType,
    settlementStatementType,
    propertyUse,
    properties,
    relatedOrders,
    subfileSuffix: incrementSubfileSuffix(subfileSuffix),
    priorPolicyAmount,
    priorPolicyDate: priorPolicyDate?.toISOString(),
    priorPolicyUnderwriterList,
    underwriterList,
    titleCompanyList,
    settlementAgentList,
    selectedPriorPolicyUnderwriter,
    selectedUnderwriter,
    selectedTitleCompany,
    settlementDate: settlementDate?.toISOString(),
    selectedSettlementAgent,
    matchedOrders,
    matchedOldOrders,
    matchedOrdersIsLoading,
    matchedOTSOrders,
    notes,
    relationshipTypeList,
    vestingList,
    contactTypeList,
    sellers,
    sellersAttorney,
    sellersParalegal,
    buyers,
    buyersAttorney,
    buyersParalegal,
    additionalContacts,
    submissionAttempted,
    autoFilled,
    totalRelatedOrdersCharLength,
    totalCharCount,
    orderPrincipal,
    orderType,
    selectedBuyerPrincipals,
    selectedSellerPrincipals,
    dealOwner
  };
}
